<template>
    <b-modal no-fade ref="modalPost" title-tag="h2" :title="title" lazy>
        <div v-if="isPending">
            <p>
                This receipt cannot be posted because the item(s) listed below
                are missing required information. Please edit the item(s) before
                posting the receipt.
            </p>

            <ul>
                <li
                    v-for="(item, index) in pendingItems"
                    :key="index"
                    class="mb-1"
                >
                    {{ item }}
                </li>
            </ul>
        </div>
        <p v-else class="m-0">
            Posting this receipt will automatically create purchase records for
            the items being received. Do you want to post this receipt?
        </p>
        <template v-slot:modal-footer="{ cancel }">
            <loader v-if="isPosting" :margin="1" />

            <b-button
                :class="isPending ? null : 'mr-auto'"
                variant="secondary"
                @click="cancel"
                v-if="!isPosting"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isPosting && !isPending"
                variant="primary"
                @click="submitPost"
            >
                Post
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";

export default {
    components: {
        Loader
    },
    data() {
        return {
            title: "",
            receiptId: null,
            isPending: false, // if there is/are items still not have `Post to` value
            isPosting: false,
            pendingItems: []
        };
    },
    methods: {
        open({ receiptId, isPending = false, pendingItems = [] }) {
            if (isPending) {
                this.title = "Action Required";
            } else {
                this.title = "Post Receipt";
            }

            this.pendingItems = pendingItems;
            this.isPending = isPending;
            this.receiptId = receiptId;
            this.$refs.modalPost.show();
        },
        async submitPost() {
            try {
                this.isPosting = true;

                let res = await this.$http.post(
                    `${process.env.BARRAMUNDI}inventory/post-receipt`,
                    {
                        purchase_order_receipt_id: this.receiptId
                    }
                );

                if (
                    res.data.response &&
                    res.data.response.message &&
                    res.data.response.message.code === 200
                ) {
                    this._message("Receipt has been posted");
                    this.$emit("reload");

                    if (this.$route.name === "receipt") {
                        this.$root.$emit("reload-receipt-items");
                    }
                    this.$refs.modalPost.hide();

                    this.$store.dispatch(
                        "inventoryReceipt/statusPost",
                        res.data.response.resources
                    );
                } else {
                    throw new Error("Error: Unable to post receipt.");
                }
            } catch (error) {
                this.isPosting = false;
                this._message(error.message, "danger");
            }
        },
        async proceedDelete() {
            try {
                this.isPosting = true;

                let res = await this.$http.delete(
                    `${process.env.BARRAMUNDI}inventory/receipt/${this.receiptId}`
                );

                if (
                    res.data.response &&
                    res.data.response.message &&
                    res.data.response.message.code === 200
                ) {
                    this._message("Receipt deleted");

                    setTimeout(() => {
                        window.location.href = `${process.env.CI_APPS}inventory/dashboard`;
                    }, 500);
                } else {
                    throw new Error("Unable to delete receipt");
                }
            } catch (e) {
                this.isPosting = false;
                this._message(e.message, "danger");
            }
        }
    }
};
</script>
